/* eslint-disable no-useless-escape */

import React from 'react';
import { cancel } from 'redux-saga/effects';
import Querystring from 'query-string';
import uniqBy from 'lodash/uniqBy';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import isString from 'lodash/isString';

import moment from 'moment';
import Services from 'services';
import { CHECK_SPELL_URL } from 'consts/api';
import { oneWayNotAllow } from 'routeConfig/checkTwoWay';
import {
  get,
  isArray,
  isBoolean,
  isEmpty,
  isNumber,
  isObject,
  isPlainObject,
  round,
  toString,
} from 'lodash';
import { ITEM_PER_PAGE, pageSize } from 'consts/filters';
import {
  CommonStatus,
  optionFilterHistory,
  SIZE_ICON,
  statusHistoryEnum,
  statusTickets,
  typeDataTrigger,
  sendMethodEnum,
  isProdEnv,
  listCountries,
} from 'consts/data';
import roles from 'consts/roles';
import { CommonIcons } from 'components/Icons';
import { queryToArray, splitObjectKeyFromUrl, stringifyUrlByParam } from './url';
import { messageLockContactRunning } from 'consts/message';
import CampaignModel from 'models/campaign.model';
import queryString from 'query-string';
import { localeNumber } from './string';

export const delayTime = (ms = 0) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
};

export const isPromiseCanceled = (error) => {
  return error?.isCanceled || error === 'canceled';
};

export const checkRouteMatchWithConditions = ({
  routes = [],
  sendMethod = '',
  messageType = '',

  countries = [],
  country = '',

  allMessageType = false,
}) => {
  const checkRoute = (countryList, detailList) => {
    if (!isArray(countryList) || !isArray(detailList)) return false;
    const newCountryList = countryList.map((elm) => elm.value);
    const newDetailList = detailList.map((elm) => elm.country);

    return newCountryList.every((elm) => newDetailList.includes(elm));
  };

  return routes.filter((route) => {
    //* Only show route active
    if (route?.status !== CommonStatus.ACTIVE) {
      return false;
    }

    if (!!country) {
      if (isArray(route?.details)) {
        return route?.details.some((detail) => {
          return (
            detail.sendMethod === sendMethod &&
            detail.country === country &&
            (allMessageType || detail.messageTypes.includes(messageType))
          );
        });
      }
    }

    //* Check country list includes route detail country
    if (!isEmpty(countries)) {
      if (!checkRoute(countries, route?.details)) {
        return false;
      }
    }

    return false;
  });
};

export const checkCountryMatchWithConditions = ({
  selectedRoute,
  routesInfo = [],
  sendMethod = '',
  countries = [],
}) => {
  const route = routesInfo.find((route) => route.id === selectedRoute);
  if (!route) return [];

  return countries.filter((elm) => {
    return (route?.details || [])
      .filter((detail) => detail.sendMethod === sendMethod)
      .map((elm) => elm.country)
      .includes(elm.iso);
  });
};

export const checkPlivoPowerPack = (phoneType = '') => {
  return isEqual('plivo_powerpack', phoneType);
};

export const getEnv = () => {
  return process.env.NODE_ENV;
};

export const getVersion = () => {
  const version = localStorage.getItem('version');

  return version;
};

export const checkIsLast = (list = [], limit = pageSize) => {
  return list.length < limit;
};

export const getOffset = (el) => {
  let rect = el.getBoundingClientRect();
  let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
};

export const getPathName = (history) => history && history.location.pathname;
export const getQuerySearch = (history) => history && Querystring.parse(history.location.search);
export const contactDetailHadResponder = (groupId, listDialog) =>
  listDialog.some((dialog) => dialog.contactGroupId === groupId);
export const findIdResponder = (groupId, listDialog) =>
  listDialog.find((dialog) => dialog.contactGroupId === groupId)?.id;

export const uniqByKeepLast = (list, key) => {
  return [...new Map(cloneDeep(list).map((x) => [key(x), x])).values()];
};

export const getNextDataRefetch = (
  responseSuccess = [], //* Response from Promise all
  numberIsLast = ITEM_PER_PAGE,
  customFieldData = undefined
) => {
  const tempArr = responseSuccess.reduce((arr, el) => {
    if (customFieldData) {
      arr = [...arr, ...(get(el?.data, customFieldData) || [])];
    } else {
      arr = [...arr, ...(el?.data || [])];
    }
    return arr;
  }, []);
  let isLast = false;
  if (customFieldData) {
    isLast =
      (get(responseSuccess[responseSuccess.length - 1]?.data, customFieldData)?.length || 0) <
      numberIsLast;
  } else {
    isLast = (responseSuccess[responseSuccess.length - 1]?.data?.length || 0) < numberIsLast;
  }

  return [tempArr, isLast];
};

export const convertToFormSelect = (
  list,
  fieldForLabel = undefined,
  fieldForValue = undefined,
  noneOption = false
) => {
  if (!isArray(list)) {
    return [];
  }

  if (!fieldForLabel || !fieldForValue) {
    return list.map((el) => ({ label: el, value: el }));
  }

  const listWithCorrectFormat = list.map((el) => ({
    ...el,
    label: el?.[fieldForLabel] || 'None',
    value: get(el, fieldForValue),
  }));

  if (noneOption) {
    return [{ label: 'None', value: '' }, ...listWithCorrectFormat];
  }

  return listWithCorrectFormat;
};

// Use for Select when value is object
export const getValueFromFormik = (value) => {
  if (typeof value === 'object') return value.value;
  return value;
};

export const isDefine = (arg) => {
  return !!toString(arg);
};

export const isDevEnvironment = () => {
  return !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
};

export const isInvalidField = (touched = {}, errors = {}, field = '') => {
  return touched[field] && !!errors[field];
};

export const removeItemByIndex = (list, index) => {
  return list.reduce((arr, el, idx) => {
    if (idx !== index) {
      arr = [...arr, el];
    }
    return arr;
  }, []);
};

export const checkIsThisAccountLogging = (email, emailOfThisAccount) => {
  return email === emailOfThisAccount;
};

export const isResponseURL = (string) => {
  if (string.includes('/')) return true;
  return false;
};

export const convertTimeStampToDate = (timestamp, format = 'MMMM DD YYYY, h:mm:ss a') =>
  moment.unix(timestamp).format(format);

export const convertAndGetValueStats = (list) => {
  return (
    list &&
    list.reduce((arr, el) => {
      arr = [...arr, el.split(' ')[2]];
      return arr;
    }, [])
  );
};

export const getFileName = (res) => {
  const filename = res.headers['content-disposition'];
  if (filename) {
    let filenameSplit = filename.split(';')[1];
    filenameSplit = filenameSplit.match(/\"(.*?)\"/g);
    if (filenameSplit) {
      return filenameSplit[0].replace(/\"/g, '');
    }
  }

  return '';
};

export const saveFile = (blob, filename) => {
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    const a = document.createElement('a');
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
  }
};

export const exportToCsv = (filename, rows) => {
  const processRow = (row) => {
    let finalVal = '';
    for (let j = 0; j < row.length; j++) {
      let innerValue = row[j] === null ? '' : row[j].toString();
      if (row[j] instanceof Date) {
        innerValue = row[j].toLocaleString();
      }
      let result = innerValue.replace(/"/g, '""');
      if (result.search(/("|,|\n)/g) >= 0) result = `"${result}"`;
      finalVal += result;
    }
    return `${(finalVal + '"').replace('"', '')}\n`;
  };

  let csvFile = '';
  for (let i = 0; i < rows.length; i++) {
    csvFile += processRow(rows[i]);
  }
  const blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
  saveFile(blob, filename);
};

export const download = (link) => {
  if (link && typeof link === 'string') {
    const tagA = document.createElement('a');
    tagA.href = link;
    tagA.click();
    tagA.remove();
  } else {
    console.log('Type link must be string!!');
  }
};

export const removeElementNotTrue = (list) =>
  list && typeof list === 'object' && list.filter((el) => el);
export const splitDataByChar = (string, char) => string && string.split(char);

export const filterNavArccodingRole = (navigation, role, twoWay = undefined) => {
  const navFake = cloneDeep(navigation);
  navFake['items'] = navFake.items.reduce((arr, el) => {
    if (twoWay === 1 && oneWayNotAllow.includes(el.name.toLowerCase())) {
      el.class = 'hide-nav';
    }

    if (!el.permission) {
      el.class = 'hide-nav';
    }

    arr = [...arr, el];
    // if (el.permission) {
    //   if (el.permission.includes('All') || el.permission.includes(role)) {
    //     if (oneWayNotAllow.includes(el.name.toLowerCase()) && twoWay === 1) {
    //       el.class = 'hide-nav';
    //       arr = [...arr, el];
    //     } else {
    //       arr = [...arr, el];
    //     }
    //   } else {
    //     el.class = 'hide-nav';
    //     arr = [...arr, el];
    //   }
    // } else arr = [...arr, el];
    return arr;
  }, []);

  return navFake;
};
export const renderWithCondition = (condition, Component) => {
  if (condition) {
    return <Component />;
  }
};
export const renderJSX = (par) => () => par;
export const isResponseSuccess = (status) => status >= 200 && status <= 299;
export const convertCurrency = (string, local) => string.toLocaleString(local);
export const clearCharacter = (string, comma) => string && string.replace(comma, '');

export const convertToFormSelectForSwitchAccount = (list) => {
  if (typeof list === 'object' && list) {
    return list.reduce((arr, el) => {
      return [
        ...arr,
        {
          ...el,
          label: `${el.username}`,
          value: el.username,
        },
      ];
    }, []);
  }
  return list;
};

// For Contact Page
export const mapListBoxWithListContact = (listBox, listContact) => {
  if (typeof listBox === 'object' && typeof listContact === 'object' && listBox && listContact) {
    return listBox.reduce((arr, el, index) => {
      arr = [...arr, el];
      listContact.forEach((el2) => {
        if (
          typeof el2.name === 'string' &&
          typeof el.name === 'string' &&
          el2.name.toLowerCase() === el.name.toLowerCase()
        ) {
          arr[index] = { ...arr[index], number: el2.count, id: el2.id };
        }
      });
      return arr;
    }, []);
  }
  return listBox;
};

// For Responder Page
export const mapListBoxWithListReplies = (listBox, listReplies) => {
  if (typeof listBox === 'object' && typeof listReplies === 'object' && listBox && listReplies) {
    return listBox.reduce((arr, el, index) => {
      arr = [...arr, el];
      listReplies.forEach((el2) => {
        if (
          typeof el2.name === 'string' &&
          typeof el.title === 'string' &&
          el2.name.toLowerCase() === el.title.toLowerCase()
        ) {
          arr[index] = { ...arr[index], ...el2 };
        }
      });
      return arr;
    }, []);
  }
  return listBox;
};

export const decodeTrueFalse = (par) => {
  if (typeof par === 'string') {
    if (par.toLowerCase() === 'true') {
      return true;
    }
    return false;
  }
  return par;
};

export const encodeTrueFalse = (par) => {
  if (typeof par === 'boolean') {
    if (par) {
      return 'true';
    }
    return 'false';
  }
  return par;
};

export const filterInListByField = (list, field, value) => {
  if (list && field && value) {
    return list.find((el) => el[field] === value);
  }
  return;
};

export const checkIsValidURL = (url) => {
  const expression =
    /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
  return expression.test(url);
};

export const numberPage = (length, records_per_page) => Math.ceil(length / records_per_page);

export const spellCheck = (text) => {
  if (text && typeof text === 'string') {
    const body = Querystring.stringify({
      disabledRules: 'WHITESPACE_RULE',
      allowIncompleteResults: true,
      text,
      language: 'en-US',
    });
    return Services.post(CHECK_SPELL_URL, body);
  }
  return '';
};

export const isAdmin = (role) => {
  if (isArray(role)) {
    return role.includes(roles.superAdmin);
  }

  return role && isString(role) && role?.toLowerCase().includes(roles.superAdmin);
};

export const convertToGroupSelect = (list) => {
  if (list && typeof list === 'object') {
    const roleGrouped = uniqBy(list, 'role').map((el) => el.role);
    const listGroupedByRole = roleGrouped.reduce((arr, role) => {
      let obj = {};
      obj = {
        ...obj,
        label: role,
        options: convertToFormSelectForSwitchAccount(list.filter((el) => el.role === role)),
      };
      arr = [...arr, obj];
      return arr;
    }, []);
    return listGroupedByRole;
  }
  return [];
};

export const stringifyListPhone = (list = []) =>
  list &&
  list
    .map((el) => `::${el.phone}`)
    .toString()
    .replace(/,/g, '');

export const getIndex = (list, id) => {
  const index = list.findIndex((el) => el.id === id);
  return index;
};

export const convertListToParamString = (listIds, field) =>
  field && typeof field === 'string'
    ? listIds.toString().replace(/\,+/gm, `&${field}=`)
    : listIds.toString().replace(/\,+/gm, '&ids=');

// Cheat hack to ON unMount and animation when open/close modal/dialog
export const toggleDialog = async (open, setOpen, close, setClose) => {
  setOpen(!open);
  setTimeout(() => {
    setClose(!close);
    /**
     * Fix freeze bug - user cannot scroll
     */
    // Check if modal exist, remove class modal-open
    const noModalExist = document.querySelectorAll("body > div[tabindex='-1']").length === 0;
    if (noModalExist) {
      console.log('%cNo modal? =>> remove modal-open', 'color: green');
      document.body.classList.remove('modal-open');
    }
  }, 500);
};

export const numberToPercentage = (number = 0) => {
  if (!number) {
    return '0';
  }

  return (Number(number) * 100).toFixed(2);
};

export const ScrollTopPosition = (position) => {
  window.scrollTo({
    top: position,
    behavior: 'smooth',
  });
};

//* ref or element or id
export const scrollElementBottom = (ref, behavior = 'smooth') => {
  if (isString(ref)) {
    setTimeout(() => {
      const DOM = document.querySelector(`#${ref}`);
      if (DOM) {
        DOM.scrollTo({
          behavior,
          top: DOM.scrollHeight,
        });
      }
    }, 60);
    return;
  }

  if (ref && ref.current) {
    ref.current.scrollTo({
      behavior,
      top: ref.current.scrollHeight,
    });
    return;
  }

  if (ref) {
    ref.scrollTo({
      behavior,
      top: ref.scrollHeight,
    });
  }
};

export const filterTypeOfValueObj = (obj) => {
  if (obj && typeof obj === 'object') {
    let tempObj = {};
    for (let key of Object.keys(obj)) {
      if (typeof obj[key] === 'function') tempObj = { ...tempObj, [key]: obj[key] };
    }
    return tempObj;
  }
  return {};
};

export const matchValueWithSelectOption = (val, options, optional = undefined) => {
  if (optional) {
    return optional(val, options);
  } else if (options && typeof options === 'object') {
    return options.find((el) => el.value === val) || null;
  }
  return {};
};

export const cloneObjectByKeys = (listKeys, obj) => {
  let tempObj = {};
  for (let val of listKeys) {
    tempObj = { ...tempObj, [val]: obj[val] };
  }
  return cloneDeep(tempObj);
};

export const suppressNonNumericInput = (event) => {
  const key = event.which || event.keyCode;
  const ctrl =
    event.ctrlKey || event.metaKey
      ? event.ctrlKey || event.metaKey
      : key === 17 || key === 91
      ? true
      : false;
  // metaKey support for Mac OS
  if (
    !(
      key === 189 ||
      key === 109 || // -
      key === 190 || //.
      key === 9 || // Tab
      key === 13 ||
      (key === 65 && ctrl) || // Ctrl + A
      (key === 86 && ctrl) || // Ctrl + V
      (key === 67 && ctrl) || // Ctrl + C
      key == 187 ||
      key == 8 || // backspace
      key == 46 || // delete
      (key >= 35 && key <= 40) || // arrow keys/home/end
      (key >= 48 && key <= 57) || // numbers on keyboard
      (key >= 96 && key <= 105)
    ) // number on keypad
  ) {
    event.preventDefault(); // Prevent character input
  }
};

export const suppressNonNumericWith =
  ({
    preventDot = false,
    preventMinus = false,
    preventPlus = false,
    preventEqual = false,
    preventUpDownArrow = false,
    allowEnter = false,
  }) =>
  (event) => {
    const key = event.which || event.keyCode;
    const ctrl =
      event.ctrlKey || event.metaKey
        ? event.ctrlKey || event.metaKey
        : key === 17 || key === 91
        ? true
        : false;

    const keyAllow =
      /[0-9]/g.test(event?.key) ||
      [
        'Backspace',
        'Tab',
        '.',
        'Delete',
        '+',
        '-',
        '=',
        'ArrowDown',
        'ArrowUp',
        'ArrowLeft',
        'ArrowRight',
      ].some((k) => k.toLowerCase() === event?.key?.toLowerCase()) ||
      (ctrl && event?.key.toLowerCase() === 'c') ||
      (ctrl && event?.key.toLowerCase() === 'v') ||
      (ctrl && event?.key.toLowerCase() === 'a') ||
      (allowEnter && event?.key === 'Enter');

    // metaKey support for Mac OS
    const preventKeys = !keyAllow;
    if (
      preventKeys ||
      (preventMinus && event?.key === '-') ||
      (preventDot && event?.key === '.') ||
      (preventEqual && event?.key === '=') ||
      (preventPlus && event?.key === '+') ||
      (preventUpDownArrow && (event?.key === 'ArrowUp' || event?.key === 'ArrowDown')) // Up / Down
    ) {
      //* Prevent all keyboard
      event.preventDefault();
    }
  };

export const suppressNonNumericWithoutDotInput = (event) => {
  const key = event.which || event.keyCode;
  const ctrl =
    event.ctrlKey || event.metaKey
      ? event.ctrlKey || event.metaKey
      : key === 17 || key === 91
      ? true
      : false;
  // metaKey support for Mac OS
  if (
    !(
      key === 189 || // -
      key === 9 || // Tab
      key === 13 ||
      (key === 65 && ctrl) || // Ctrl + A
      (key === 86 && ctrl) || // Ctrl + V
      (key === 67 && ctrl) || // Ctrl + C
      key == 187 ||
      key == 8 || // backspace
      key == 46 || // delete
      (key >= 35 && key <= 40) || // arrow keys/home/end
      (key >= 48 && key <= 57) || // numbers on keyboard
      (key >= 96 && key <= 105)
    ) // number on keypad
  ) {
    event.preventDefault(); // Prevent character input
  }
};

export const suppressNonDotInput = (event) => {
  if (event.keyCode === 190) event.preventDefault();
};

export const onlyNumbersInput = (event) => {
  if (
    !/[0-9]/.test(event.key) &&
    event.key !== 'Backspace' &&
    event.key !== 'Enter' &&
    event.key !== 'Tab' &&
    event.key !== 'ArrowLeft' &&
    event.key !== 'ArrowRight'
  ) {
    event.preventDefault();
  }
};

export const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const checkTypeValue = (val, type) => typeof val === type;

export const printGender = (gender) => {
  if (gender === 'f') return 'Female';
  return 'Male';
};

export const trimListString = (list) => {
  // If all element is string type
  if (list.every((el) => typeof el === 'string')) {
    return list.map((el) => el.trim());
  }
  if (list.every((el) => typeof el === 'undefined')) {
    return list.map(() => '');
  }
  return list;
};

export const hasDuplicateItem = (list) => {
  return (
    list &&
    typeof list === 'object' &&
    list.filter((el, index) => !isEqual(list.indexOf(el), index)).length > 0
  );
};

export const filterDuplicateItem = (list) => {
  return list.filter((el, index) => !isEqual(list.indexOf(el), index));
};

export const checkIfListIsEmpty = (list) => list.filter((el) => el).length <= 0;

export const IsJsonString = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const bytesToMegaBytes = (bytes) => (bytes / Math.pow(1024, 2)).toFixed(2);

export const flattenObject = (ob) => {
  let toReturn = {};

  for (let i in ob) {
    if (!ob.hasOwnProperty(i)) continue;

    if (typeof ob[i] == 'object' && ob[i] !== null) {
      let flatObject = flattenObject(ob[i]);
      for (let x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue;

        toReturn[i + '.' + x] = flatObject[x];
      }
    } else {
      toReturn[i] = ob[i];
    }
  }
  return toReturn;
};

export const removeNullOfObject = (obj = {}, exceptFields = []) => {
  let tempObj = {};
  for (let key of Object.keys(obj)) {
    if (exceptFields.includes(key) || obj[key]) {
      tempObj[key] = obj[key];
    }
  }

  return tempObj;
};

export const checkHistoryCompleted = (history) => {
  return toString(history?.status).toLowerCase() === statusHistoryEnum.completed;
};

export const checkHistoryPaused = (history) => {
  return toString(history?.status).toLowerCase().includes(statusHistoryEnum.paused);
};

export const checkHistoryRunning = (history) => {
  return toString(history?.status)
    .toLowerCase()
    .includes(statusHistoryEnum.running || 'processing');
};

export const checkHistoryScheduled = (history) => {
  const status = toString(history?.status).toLowerCase();
  return status.includes(statusHistoryEnum.scheduled) || status.includes('scheduling');
};

export const checkHistoryPauseAsDIDNotAvailable = (history) => {
  const status = toString(history?.status).toLowerCase();
  return status === 'Paused_DidNotAvailable'.toLowerCase();
};

export const getStatusTicket = (status) => {
  const result = statusTickets.find((el) => el.value === status);
  return {
    label: result?.label || '',
    className: result?.className || '',
  };
};
export function* cancelTask(task) {
  yield cancel(task);
}

export const genPagination = (numberOfPage = 0) => {
  let tempArr = [];
  for (let i = 0; i < numberOfPage; i++) {
    tempArr = [...tempArr, { label: i + 1, value: i + 1 }];
  }

  return tempArr;
};

export const copyToClipboard = (text = '') => {
  const el = document.createElement('textarea');
  el.value = text;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};

export const filterQueryInHeaderField = (headerField = [], query = {}) => {
  const mapValHeaderField = headerField?.map((el) => el.value);
  let itemInHeaderField = {};
  let itemNotInHeaderField = {};
  Object.keys(query).forEach((key) => {
    //* For case { key: ["value1", "value2", "value3" ]}
    if (isArray(query[key])) {
      let tempArrParams = [];
      (query[key] || []).forEach((val, idx) => {
        if (mapValHeaderField.includes(val)) {
          tempArrParams = [...tempArrParams, val];
        }
      });
      itemInHeaderField[key] = tempArrParams;
    } else if (mapValHeaderField.includes(query[key])) {
      itemInHeaderField[key] = query[key];
    } else {
      itemNotInHeaderField[key] = query[key];
    }
  });

  return { itemInHeaderField, itemNotInHeaderField };
};

export const findValueInOptions = (
  valueField = '',
  options = [],
  nameFieldOfOptions = 'value',
  defaultDataIfNotFound = {
    label: '',
    value: '',
  }
) => {
  return (
    options?.find((el) =>
      isEqual(
        (valueField || '').toString().toLocaleLowerCase(),
        (el[nameFieldOfOptions] || '').toString().toLocaleLowerCase()
      )
    ) || defaultDataIfNotFound
  );
};

export const checkIsTabTrigger = (tab) => {
  return typeDataTrigger.map((el) => `${el.value}`).includes(`${tab}`);
};

export const checkStatusBestCampaign = (bestCampaign = {}) => {
  const findHistoryStatus = (status = '') => {
    return optionFilterHistory?.find((el) => el.value.toString() === status) || {};
  };

  let status = findHistoryStatus(statusHistoryEnum.running)?.value || '';

  if (checkHistoryCompleted(bestCampaign)) {
    status = findHistoryStatus(statusHistoryEnum.completed)?.value;
  }

  if (checkHistoryPaused(bestCampaign)) {
    status = findHistoryStatus(statusHistoryEnum.paused)?.value;
  }

  return status;
};

export const cloneAndTransferKey = (obj = {}, arrCompare = []) => {
  const cloneObj = cloneDeep(obj);
  for (let item of arrCompare) {
    const keyOrigin = item[0] || '';
    const keyTransfer = item[1] || '';

    cloneObj[keyTransfer] = cloneObj[keyOrigin];
    delete cloneObj[keyOrigin];
  }

  return cloneObj || {};
};

export const detectBrowserHidden = () => {
  let hidden;
  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden';
  } else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden';
  } else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
  }
  return {
    isHidden: document[hidden],
  };
};

export const isProcessingImportFile = (status = '') => {
  return status !== 'processing file';
};

export const isValidToCountContact = ({ failed, nonClicked, nonReply }) => {
  return failed || nonClicked || nonReply;
};

export const insert = (arr, index, ...newItems) => [
  // part of the array before the specified index
  ...arr.slice(0, index),
  // inserted items
  ...newItems,
  // part of the array after the specified index
  ...arr.slice(index),
];

export const browserDetect = () => {
  const userAgent = window.navigator.userAgent;

  if (userAgent.match(/chrome|chromium|crios/i)) {
    return 'chrome';
  }
  if (userAgent.match(/firefox|fxios/i)) {
    return 'firefox';
  }
  if (userAgent.match(/safari/i)) {
    return 'safari';
  }
  if (userAgent.match(/opr\//i)) {
    return 'opera';
  }
  if (userAgent.match(/edg/i)) {
    return 'edge';
  }

  return 'No browser detection';
};

export const checkLinkHttps = (link = '') => {
  if (isString(link)) {
    return link.includes('https') || link.includes('http');
  }

  return false;
};

export const exportCSV = (data = [], name = '') => {
  if (isArray(data)) {
    let csvContent = 'data:text/csv;charset=utf-8,';

    (data || []).forEach(function (rowArray) {
      //* Handle comma each col
      const newRowArray = rowArray.map((el) => {
        if (el.includes(',') || el.startsWith('+')) {
          return `\"${el}\"`;
        }

        return el;
      });

      let row = newRowArray.join(',');
      csvContent += row + '\r\n';
    });

    let encodedUri = encodeURI(csvContent);
    let link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', name + '.csv');
    document.body.appendChild(link); // Required for FF

    link.click();
    link.remove();
  }

  if (isString(data)) {
    let encodedUri = encodeURI(`data:text/csv;charset=utf-8, ${data}`);
    let link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', name + '.csv');
    document.body.appendChild(link); // Required for FF

    link.click();
    link.remove();
  }
};

export const hexToBase64 = (str) => {
  return btoa(
    String.fromCharCode.apply(
      null,
      str
        .replace(/\r|\n/g, '')
        .replace(/([\da-fA-F]{2}) ?/g, '0x$1 ')
        .replace(/ +$/, '')
        .split(' ')
    )
  );
};

//* fileName or fileExtension
export const checkIsImageFile = (fileName) => {
  if (!isString(fileName)) {
    return false;
  }

  const listPrefixFile = [
    '.png',
    '.svg',
    '.webp',
    '.jpg',
    '.jpeg',
    '.jfif',
    '.pjpeg',
    '.pjp',
    '.gif',
  ];
  return listPrefixFile.reduce((result, prefix) => {
    if (`.${fileName.toLowerCase()}`.includes(prefix)) {
      result = true;
    }

    return result;
  }, false);
};

export const checkIsAudioFile = (typeFile) => {
  return isString(typeFile) && typeFile.includes('audio/');
};

export const checkIsVideoFile = (typeFile) => {
  return isString(typeFile) && typeFile.includes('video/');
};

export const hideTokenSecret = (tokenSecret) => {
  if (isString(tokenSecret)) {
    const lengthOfString = tokenSecret.length;
    const renderAsterisk = Array(tokenSecret.slice(lengthOfString - 4, lengthOfString).length)
      .fill()
      .map(() => '*')
      .join('');
    return `${tokenSecret.slice(0, lengthOfString - 4)}${renderAsterisk}`;
  }

  return '';
};

export const checkHasMoreItem = (resDataLength, limit) => {
  return resDataLength.length >= limit;
};

export const getRowInTable = (propsCell = {}) => {
  if (isObject(propsCell) && propsCell?.row?.original) {
    return propsCell?.row?.original || {};
  }

  if (isObject(propsCell) && propsCell?.original) {
    return propsCell?.original || {};
  }

  return {};
};

export const genExpanderTableCol = (options = {}) => {
  return {
    id: 'expander',
    Header: '',
    // Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (
    //   <span {...getToggleAllRowsExpandedProps()}>
    //     {isAllRowsExpanded ? (
    //       <CommonIcons.Expand size={SIZE_ICON} />
    //     ) : (
    //       <CommonIcons.Collapse size={SIZE_ICON} />
    //     )}
    //   </span>
    // ),
    Cell: ({ row }) => (
      <span {...row.getToggleRowExpandedProps()} {...options}>
        {row.isExpanded ? (
          <CommonIcons.Expand size={SIZE_ICON} />
        ) : (
          <CommonIcons.Collapse size={SIZE_ICON} />
        )}
      </span>
    ),
  };
};

export const genBuilderFullfill = (config = '') => {
  if (isString(config)) {
    return {
      config: `${stringifyUrlByParam(
        queryToArray(splitObjectKeyFromUrl(config || '')),
        'param',
        'value'
      )}`,
      params: queryToArray(splitObjectKeyFromUrl(config || '')),
    };
  }

  return {
    config: '',
    params: '',
  };
};

export const genBuilderPrefill = (originalUrl = '', params = [], isPrefillNotHasHostUrl) => {
  const query = Querystring.parseUrl(originalUrl)?.query || {};
  const host = !!isPrefillNotHasHostUrl ? '' : Querystring.parseUrl(originalUrl).url;
  const queryOfOriginUrl = Querystring.stringify(query, {
    arrayFormat: 'bracket-separator',
    arrayFormatSeparator: '|',
  });
  const queryParams =
    params.length > 0 ? `${stringifyUrlByParam(params, 'param', 'value')}`.replace('?', '') : '';

  let fullDomain = '';
  if (queryOfOriginUrl) {
    fullDomain = `${host}?${queryOfOriginUrl}&${queryParams}`;
  } else {
    fullDomain = `${host}?${queryParams}`;
  }

  return fullDomain;
};

export const convertKYCImgToBase64 = (src = '') => {
  if (isString(src)) {
    return `data:image/png;base64,${src}`;
  }

  console.error('Img src KYC must be string type!');
};

export const isNumeric = (n) => {
  return n !== '' && n !== undefined && n !== null && !isNaN(parseFloat(n)) && isFinite(n);
};

export const convertStringToList = (string, comma = ',') => {
  if (isString(string)) {
    return string
      .split(comma)
      .map((el) => el.trim())
      .filter((el) => !!el);
  }

  console.error('Parameter must be string type!');
  return [];
};

/**
 *
 * @param {*} base64
 * @param {string | audio/wav} fileType
 * @returns
 */
export const parseBase64ToFile = (base64, fileType) => {
  return `data:${fileType};base64,` + base64;
};

export const convertNumberOneCharTo2Char = (number) => {
  if (isNumeric(number)) {
    let nextNumber = number;
    if (`${number}`.length <= 1) {
      nextNumber = `0${nextNumber}`;
    }

    return nextNumber;
  }
  console.error('convertNumberOneCharTo2Char: Number is not numeric');
  return '';
};

export const findIndexOfAllRepeatationOfStringInString = (data, target) => {
  let index = 0;
  const indexes = [];
  while (index !== -1) {
    index = data.indexOf(target, index);
    if (index !== -1) {
      const open = data.slice(index).indexOf('<');
      const close = data.slice(index).indexOf('>');
      const prevOpen = data.slice(0, index).lastIndexOf('<');
      const prevClose = data.slice(0, index).lastIndexOf('>');

      //* if close > open => it's not a tag
      if (
        close > open &&
        !(prevOpen > prevClose && prevOpen < data.slice(0, index).length + close)
      ) {
        indexes.push(index);
      }
      index += 1;
    }
  }

  return indexes;
};

export const removeKeyFromObj = (obj = {}, fields = []) => {
  if (isObject(obj)) {
    const nextObj = cloneDeep(obj);
    fields.forEach((field) => {
      delete nextObj[field];
    });
    return nextObj;
  }

  return {};
};

export const uniqByLatest = (array, field) => {
  //* What difference with uniqBy? -> uniqBy will uniq all value from left -> right and uniqByLatest is vice versa
  const arrUniqByField = uniqBy(array.map((el) => el?.[field]));
  const uniqArrByField = arrUniqByField.reduce((nextArr, el) => {
    const lastIndexEachItem = array.findLastIndex((value) => value?.[field] === el);

    nextArr = [...nextArr, array[lastIndexEachItem]];

    return nextArr;
  }, []);

  return uniqArrByField;
};

export const isDefineValueOr = (value, valueException = undefined) => {
  if (
    isNumber(value) ||
    isObject(value) ||
    isArray(value) ||
    isBoolean(value) ||
    (isString(value) && value !== '')
  ) {
    return value;
  }

  return valueException;
};

export const trimAllValuesInObject = (values) => {
  if (isObject(values)) {
    const nextValues = cloneDeep(values);

    const recursive = (obj) => {
      Object.entries(obj).forEach(([key, value]) => {
        if (isObject(value)) {
          recursive(value);
        }

        obj[key] = isString(value) ? value.trim() : value;
      });
    };

    recursive(nextValues);
    return nextValues;
  }

  return {};
};

export const handleBodyRequestCommon = (arg) => {
  if (arg instanceof FormData) {
    return arg;
  }

  if (isObject(arg)) {
    const nextArg = cloneDeep(arg);

    const recursive = (obj) => {
      Object.entries(obj).forEach(([key, value]) => {
        if (isObject(value)) {
          recursive(value);
        }

        obj[key] = isString(value) ? value.trim() : value;
      });
    };

    recursive(nextArg);
    return nextArg;
  }

  if (isString(arg)) {
    return arg.trim();
  }

  return arg;
};

export const getArrayHelpers = (propsArrayField) => {
  const { name, arrayHelpers } = propsArrayField;
  const { form, ...rest } = arrayHelpers || {};

  const thisValue = get(form.values, name);

  return {
    name,
    form,
    value: thisValue,
    ...rest,
  };
};

export const genTitleCreativeByAssistant = (historyAssistant) => {
  const { id, category, campaignGoal } = historyAssistant || {};

  return `${category}_${campaignGoal}_${id}`;
};

export const checkSwitchQRAndAttachment = (
  routesInfo,
  routesOneWay,
  routesTwoWays,
  country,
  sendMethod,
  messageType
) => {
  if (!CampaignModel.isMessageTypeSupportAttachment(messageType)) {
    return false;
  }

  if (isArray(routesOneWay) && isArray(routesTwoWays)) {
    const routes =
      sendMethod === sendMethodEnum.oneWay ? cloneDeep(routesOneWay) : cloneDeep(routesTwoWays);

    if (isEmpty(routes)) return false;

    return routes.every((route) => {
      const routeInfo =
        sendMethod === sendMethodEnum.twoWays
          ? cloneDeep(routesInfo).find((item) => item.id === route.routeId)
          : route;
      if (isArray(routeInfo?.details)) {
        return cloneDeep(routeInfo?.details)
          .filter((item) => item?.country === country)
          .every((item) => {
            return item?.supportAttachment;
          });
      }
      return false;
    });
  }

  return false;
};

export const checkIsContactInProcessing = (message = '') => {
  return new RegExp(messageLockContactRunning.toLowerCase(), 'g').test(message.toLowerCase());
};

export const formatBytes = (bytes, decimals) => {
  if (bytes == 0) {
    return '0 Byte';
  }
  var k = 1024; //Or 1 kilo = 1000
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i];
};

export const file2Base64 = (file) => {
  if (isString(file)) {
    return file;
  }

  return window.URL.createObjectURL(file);
};

export const countWords = (str) => {
  if (isEmpty(str) || !isString(str)) {
    return 0;
  }

  let nextStr = str || '';

  nextStr = nextStr.replace(/[^\w\s]/g, '');

  const words = nextStr.split(/\s+/);

  return words.length;
};

export const isStringArray = (array) => {
  if (!isEmpty(array)) {
    return false;
  }

  return array.every((el) => isString(el));
};

export const sortByAlphabet = (array, key) => {
  if (!!key) {
    return cloneDeep(array).sort(function (a, b) {
      if (a[key] < b[key]) {
        return -1;
      }
      if (a[key] > b[key]) {
        return 1;
      }
      return 0;
    });
  }

  return cloneDeep(array).sort();
};

export const isReactComponent = (element) => {
  return React.isValidElement(element);
};

const BASE64_MARKER = ';base64,';
export const convertDataURIToBinary = (dataURI) => {
  const base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
  const base64 = dataURI.substring(base64Index);
  const raw = window.atob(base64);
  const rawLength = raw.length;
  const array = new Uint8Array(new ArrayBuffer(rawLength));

  for (let i = 0; i < rawLength; i++) {
    array[i] = raw.charCodeAt(i);
  }

  return array;
};

export const isStringHasHTMLTags = (string = '') => {
  if (isString(string)) {
    return /<\/?[a-z][\s\S]*>/g.test(string);
  }

  return false;
};

export function arraybuffer2str(buf) {
  return String.fromCharCode.apply(null, new Uint16Array(buf));
}

export function string2arraybuffer(str) {
  var buf = new ArrayBuffer(str.length * 2); // 2 bytes for each char
  var bufView = new Uint16Array(buf);
  for (var i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
}

export function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export const genBgColorPackage = (type) => {
  const bg = {
    BASIC: 'bg-color-primary-v2',
    PRO: 'bg-color-warning-v2',
    ENTERPRISE: 'bg-color-success-v2',
    CUSTOM: 'bg-color-black',
  };

  return bg?.[type] || '';
};

export const genColorTextPackage = (type) => {
  const color = {
    BASIC: 'color-white',
    PRO: 'tw-text-black',
    ENTERPRISE: 'color-white',
    CUSTOM: 'color-white',
  };

  return color?.[type] || '';
};

export const DivElement = React.memo(({ children, ...rest }) => {
  return <div {...rest}>{children}</div>;
});

export const checkResponseMsgErr = (response) => {
  if (isString(response?.data) && !!response?.data) {
    return response?.data;
  }

  return null;
};

export const getQueryStringFromURL = () => {
  return queryString.parse(window.location.search);
};

export function countSquareBrackets(input) {
  let count = 0;
  for (let i = 0; i < input.length; i++) {
    if (input[i] === '[') {
      count++;
    }
  }
  return count;
}

//* Change key is value and value is key in Object
export const switchKeyToValues = (obj) => {
  if (isPlainObject(obj)) {
    return Object.entries(obj).reduce((nextObj, el) => {
      const [key, value] = el;

      nextObj[value] = key;

      return nextObj;
    }, {});
  }

  return {};
};

export function isReactFragment(variableToInspect) {
  if (variableToInspect.type) {
    return variableToInspect.type === React.Fragment;
  }
  return variableToInspect === React.Fragment;
}

export const checkIs404 = (error) => {
  return isString(error) && error.includes('404');
};

export const roundCurrency = (number) => {
  return round(number, 5);
};

export const getIPAddressUI = () => {
  const ip = isProdEnv ? '35.244.183.56' : '34.36.185.153';
  return ip;
};

export const isCorrectForwardPhone = (number) => {
  if (isString(number)) {
    return /^\+[0-9]*$/.test(number);
  }

  return false;
};

export const showCost = (value, numberDecimal) => {
  if (!isNumeric(value)) {
    return null;
  }

  if (!value) {
    return 0;
  }

  return localeNumber(Number(value).toFixed(numberDecimal || 2));
};

export function msToTime(duration) {
  var milliseconds = parseInt((duration % 1000) / 100),
    seconds = Math.floor((duration / 1000) % 60),
    minutes = Math.floor((duration / (1000 * 60)) % 60),
    hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  seconds = seconds < 10 ? '0' + seconds : seconds;

  return hours + ':' + minutes + ':' + seconds + '.' + milliseconds;
}

export function isArrayIncludeObject(array, objectCompare) {
  return (array || []).some((el) => isEqual(el, objectCompare));
}

export const getCountryName = (countryCode) => {
  return listCountries.find((elm) => elm.code === countryCode)?.name || '';
};

export function base64ToBlob(base64Data, mimeType) {
  const byteCharacters = atob(base64Data.split(',')[1]); // Decode Base64 string
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
    const slice = byteCharacters.slice(offset, offset + 1024);
    const byteNumbers = new Array(slice.length);

    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: mimeType }); // Adjust MIME type as needed
}

// Function to convert audio buffer to PCM16 format
export function convertToPCM16(inputBuffer) {
  const channelData = inputBuffer.getChannelData(0); // Get the audio data from the first channel
  const pcm16Array = new Int16Array(channelData.length);

  for (let i = 0; i < channelData.length; i++) {
    // Convert each sample from float (-1 to 1) to PCM 16-bit signed integer (-32768 to 32767)
    pcm16Array[i] = Math.max(-32768, Math.min(32767, Math.round(channelData[i] * 32767)));
  }

  return pcm16Array;
}

// Function to convert PCM16 data to Base64
export function convertToBase64(pcm16Data) {
  const pcm16Blob = new Blob([pcm16Data], { type: 'audio/raw' });
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onloadend = () => {
      const base64Audio = reader.result.split(',')[1]; // Extract the Base64 string
      resolve(base64Audio);
    };
    reader.onerror = reject;
    reader.readAsDataURL(pcm16Blob);
  });
}

export const convertCountryListToSelectOptions = (list) => {
  return list.map((el) => ({
    label: el.name,
    value: el.code,
  }));
};
